export default function bindHtmlDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: bindHtmlDirectiveCtrl,
	};
}

class bindHtmlDirectiveCtrl {
	constructor($scope, $element, $attrs) {
		'ngInject';
		$scope.$watch($attrs.shBindHtml, newVal => {
			if (newVal === undefined || newVal === false || newVal === null) {
				return;
			}
			// do not escape newVal is meant to render HTML as provided
			$element[0].innerHTML = newVal || '';
		});
	}
}
